import styled, { css } from 'styled-components';

export const SWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const SList = styled.div`
  width: 100%;
  height: 100%;

  @media (orientation: landscape) {
    height: calc(100% - 38px);
    position: absolute;
  }
`;

export const STitlesWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const STitle = styled.div<{ titleId: string }>`
  color: rgba(var(--grid-title), 0.5);
  font-weight: 400;
  font-size: 12px;
  width: 75px;
  text-align: right;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:first-child {
    text-align: left;
  }

  &:first-child,
  &:last-child {
    padding: 0 4px;
  }

  ${({ titleId }) =>
    titleId === 'user' &&
    css`
      width: 85px;
    `}

  ${({ titleId }) =>
    titleId === 'bonuses' &&
    css`
      width: 15px;
    `}
`;

export const SNoBets = styled.div`
  height: calc(100% - 50px);
  font-size: 18px;
  font-weight: 400;
  color: rgba(var(--txt-h1), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
`;
